import type * as THREE from 'three/webgpu';
import type { SelectionUpdatedEventPayload } from '../../../../manager/EntitySelectionManager';

/**
 * 解析转换实体引用应消费的选择目标对象。
 *
 * 说明：
 * 1. 选择系统的 `object` 表达普通编辑语义，例如槽口边点击会提升为槽口整体；
 * 2. 转换实体引用需要按用户真实点到的几何边生成来源，因此优先读取 `selectionSourceObject`；
 * 3. 没有原始命中对象时回退到语义选中对象，保持程序化选择与框选路径兼容。
 *
 * @param payload 选择结算事件。
 * @returns 转换实体引用应参与候选解析的对象。
 */
export function resolveSketchEntityReferenceSelectionTargetObject(
	payload: Pick<SelectionUpdatedEventPayload, 'object' | 'selectionSourceObject'>,
): THREE.Object3D | null {
	return payload.selectionSourceObject ?? payload.object;
}
